import moment from "moment";
import { InquiryValues } from "types/inquiry-values";

interface AdjustmentData {
    type: "time" | "activity";
    original: string;
    proposed: string;
}

/**
 * Formats inquiry adjustments for display in the booking request respond modal
 * Returns structured data for rendering with components
 */
export const formatInquiryAdjustments = (
    inquiryValues: InquiryValues | undefined
): AdjustmentData[] => {
    if (!inquiryValues) {
        return [];
    }

    const adjustments: AdjustmentData[] = [];

    // Format time changes if they exist
    if (inquiryValues.originalStart && inquiryValues.proposedStart) {
        const originalDate = inquiryValues.originalStart.format("YYYY-MM-DD");
        const proposedDate = inquiryValues.proposedStart.format("YYYY-MM-DD");
        const originalTime = inquiryValues.originalStart.format("HH:mm");
        const proposedTime = inquiryValues.proposedStart.format("HH:mm");

        // Check if date or time changed
        if (originalDate !== proposedDate || originalTime !== proposedTime) {
            adjustments.push({
                type: "time",
                original: inquiryValues.originalStart
                    .locale(moment.locale())
                    .format("HH:mm ddd D MMMM"),
                proposed: inquiryValues.proposedStart
                    .locale(moment.locale())
                    .format("HH:mm ddd D MMMM"),
            });
        }
    }

    // Format activity changes if they exist
    if (inquiryValues.originalActivities && inquiryValues.proposedActivities) {
        const originalActivityNames = inquiryValues.originalActivities
            .map((activity) => activity.name)
            .join(", ");
        const proposedActivityNames = inquiryValues.proposedActivities
            .map((activity) => activity.name)
            .join(", ");

        if (originalActivityNames !== proposedActivityNames) {
            adjustments.push({
                type: "activity",
                original: originalActivityNames,
                proposed: proposedActivityNames,
            });
        }
    }

    return adjustments;
};
